export interface PdfCanvasProps {
  url: string;
  className?: string;
}

export const PDF_CANVAS_MAX_PIXEL_RATIO = 2;
